// Image widget. Legacy: addImage/handleImageUpload (L4116-4151).
// Fabric v7 (map §4.2): FabricImage.fromURL returns a Promise (was a callback).
// SVG import + filters + corner-radius + background-image mode land in Phase 2.
import { FabricImage } from 'fabric'
import { getCanvas } from './../state'
import { labelPx } from './../canvas'

/** Load a raster image file onto the canvas, scaled to fit the label. */
export async function addImageFromFile(file: File): Promise<void> {
  if (file.name.toLowerCase().endsWith('.svg') || file.type === 'image/svg+xml') {
    // TODO(Phase 2): handleSVGImport via loadSVGFromString (map §4.2/§4.3).
    console.warn('[olm-editor] SVG import not wired until Phase 2')
    return
  }
  const dataUrl = await readAsDataURL(file)
  const img = await FabricImage.fromURL(dataUrl, { crossOrigin: 'anonymous' })

  const { w, h } = labelPx()
  const maxW = w * 0.6
  const maxH = h * 0.6
  const scale = Math.min(maxW / img.width, maxH / img.height, 1)
  img.set({
    left: w / 2 - (img.width * scale) / 2,
    top: h / 2 - (img.height * scale) / 2,
    scaleX: scale,
    scaleY: scale,
    id: 'img-' + Date.now(),
  } as any)

  const canvas = getCanvas()
  canvas.add(img)
  canvas.setActiveObject(img)
  canvas.requestRenderAll()
}

function readAsDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}
